export default {
    lang: 'en',
    dir: 'ltr',
    common: {
        ok: 'OK',
        cancel: 'Cancel',
        key_backspace: 'Backspace',
        key_del: 'Del',
        key_down: 'Down',
        key_up: 'Up',
        more_opts: 'More options',
        url: 'URL',
        width: 'Width',
        height: 'Height'
    },
    misc: {
        powered_by: 'Powered by'
    },
    ui: {
        toggle_stroke_tools: 'Show/hide more stroke tools',
        palette_info: 'Click to change fill color, shift-click to change stroke color',
        zoom_level: 'Change zoom level',
        panel_drag: 'Drag left/right to resize side panel',
        quality: 'Quality:',
        pathNodeTooltip: 'Drag node to move it. Double-click node to change segment type',
        pathCtrlPtTooltip: 'Drag control point to adjust curve properties',
        pick_stroke_paint_opacity: 'Pick a Stroke Paint and Opacity',
        pick_fill_paint_opacity: 'Pick a Fill Paint and Opacity'
    },
    properties: {
        id: 'Identify the element',
        fill_color: 'Change fill color',
        stroke_color: 'Change stroke color',
        stroke_style: 'Change stroke dash style',
        stroke_width: 'Change stroke width by 1, shift-click to change by 0.1',
        pos_x: 'Change X coordinate',
        pos_y: 'Change Y coordinate',
        linecap_butt: 'Linecap: Butt',
        linecap_round: 'Linecap: Round',
        linecap_square: 'Linecap: Square',
        linejoin_bevel: 'Linejoin: Bevel',
        linejoin_miter: 'Linejoin: Miter',
        linejoin_round: 'Linejoin: Round',
        angle: 'Change rotation angle',
        blur: 'Change gaussian blur value',
        opacity: 'Change selected item opacity',
        circle_cx: "Change circle's cx coordinate",
        circle_cy: "Change circle's cy coordinate",
        circle_r: "Change circle's radius",
        ellipse_cx: "Change ellipse's cx coordinate",
        ellipse_cy: "Change ellipse's cy coordinate",
        ellipse_rx: "Change ellipse's x radius",
        ellipse_ry: "Change ellipse's y radius",
        line_x1: "Change line's starting x coordinate",
        line_x2: "Change line's ending x coordinate",
        line_y1: "Change line's starting y coordinate",
        line_y2: "Change line's ending y coordinate",
        rect_height: 'Change rectangle height',
        rect_width: 'Change rectangle width',
        corner_radius: 'Change Rectangle Corner Radius',
        image_width: 'Change image width',
        image_height: 'Change image height',
        image_url: 'Change URL',
        node_x: "Change node's x coordinate",
        node_y: "Change node's y coordinate",
        seg_type: 'Change Segment type',
        straight_segments: 'Straight',
        curve_segments: 'Curve',
        text_contents: 'Change text contents',
        font_family: 'Change Font Family',
        font_size: 'Change Font Size',
        bold: 'Bold Text [B]',
        italic: 'Italic Text [I]',
        text_anchor_start: 'Align the text in start',
        text_anchor_middle: 'Align the text in middle',
        text_anchor_end: 'Align the text in end'
    },
    tools: {
        main_menu: 'Main Menu',
        bkgnd_color_opac: 'Change background color/opacity',
        connector_no_arrow: 'No arrow',
        fitToContent: 'Fit to Content',
        fit_to_all: 'Fit to all content',
        fit_to_canvas: 'Fit to canvas',
        fit_to_layer_content: 'Fit to layer content',
        fit_to_sel: 'Fit to selection',
        align_relative_to: 'Align relative to ...',
        relativeTo: 'relative to:',
        page: 'page',
        largest_object: 'largest object',
        selected_objects: 'selected objects',
        smallest_object: 'smallest object',
        new_doc: 'New Panel',
        open_doc: 'Open Panel',
        export_img: 'Export',
        save_doc: 'Save Panel',
        save_doc_as: 'Save Panel As',
        import_to_layer: 'Import SVG as layer',
        import_doc: 'Import Image',
        align_to_page: 'Align Element to Page',
        align_bottom: 'Align Bottom',
        align_center: 'Align Center',
        align_left: 'Align Left',
        align_middle: 'Align Middle',
        align_right: 'Align Right',
        align_top: 'Align Top',
        mode_select: 'Select Tool',
        mode_fhpath: 'Pencil Tool',
        mode_line: 'Line Tool',
        mode_rect: 'Rectangle Tool',
        mode_square: 'Square Tool',
        mode_fhrect: 'Free-Hand Rectangle',
        mode_ellipse: 'Ellipse',
        mode_circle: 'Circle',
        mode_fhellipse: 'Free-Hand Ellipse',
        mode_path: 'Path Tool',
        mode_text: 'Text Tool',
        mode_image: 'Image Tool',
        mode_zoom: 'Zoom Tool [Ctrl+Up/Down]',
        no_embed: 'NOTE: This image cannot be embedded. It will depend on this path to be displayed',
        undo: 'Undo [Z]',
        redo: 'Redo [Y]',
        tool_source: 'Edit Source',
        wireframe_mode: 'Wireframe Mode',
        clone: 'Duplicate Element(s) [D]',
        del: 'Delete Element(s) [Delete/Backspace]',
        group_elements: 'Group Elements [G]',
        make_link: 'Make (hyper)link',
        set_link_url: 'Set link URL (leave empty to remove)',
        to_path: 'Convert to Path',
        reorient_path: 'Reorient path',
        ungroup: 'Ungroup Elements',
        docprops: 'Document Properties',
        editor_homepage: 'SVG-Edit Home Page',
        move_bottom: 'Send to Back',
        move_top: 'Bring to Front',
        node_clone: 'Clone Node',
        node_delete: 'Delete Node',
        node_link: 'Link Control Points',
        add_subpath: 'Add sub-path',
        openclose_path: 'Open/close sub-path',
        source_save: 'Apply Changes',
        cut: 'Cut',
        copy: 'Copy',
        paste: 'Paste',
        paste_in_place: 'Paste in Place',
        delete: 'Delete',
        group: 'Group',
        move_front: 'Bring to Front',
        move_up: 'Bring Forward',
        move_down: 'Send Backward',
        move_back: 'Send to Back'
    },
    layers: {
        layer: 'Layer',
        layers: 'Layers',
        del: 'Delete Layer',
        move_down: 'Move Layer Down',
        new: 'New Layer',
        rename: 'Rename Layer',
        move_up: 'Move Layer Up',
        dupe: 'Duplicate Layer...',
        merge_down: 'Merge Down',
        merge_all: 'Merge All',
        move_elems_to: 'Move elements to:',
        move_selected: 'Move selected elements to a different layer'
    },
    config: {
        image_props: 'Image Properties',
        doc_title: 'Title:',
        doc_dims: 'Canvas Dimensions',
        included_images: 'Included Images',
        image_opt_embed: 'Embed data (local files)',
        image_opt_ref: 'Use file reference',
        editor_prefs: 'Editor Preferences',
        icon_size: 'Icon size:',
        language: 'Language:',
        background: 'Editor Background',
        editor_img_url: 'Image URL:',
        editor_bg_note: 'Note: Background will not be saved with image.',
        icon_large: 'Large',
        icon_medium: 'Medium',
        icon_small: 'Small',
        icon_xlarge: 'Extra Large',
        select_predefined: 'Select predefined:',
        units_and_rulers: 'Units & Rulers',
        show_rulers: 'Show rulers',
        base_unit: 'Base Unit:',
        grid: 'Grid',
        snapping_onoff: 'Snapping on/off',
        snapping_stepsize: 'Snapping Step-Size:',
        grid_color: 'Grid color:'
    },
    notification: {
        invalidAttrValGiven: 'Invalid value given',
        noContentToFitTo: 'No content to fit to',
        dupeLayerName: 'There is already a layer named that!',
        enterUniqueLayerName: 'Please enter a unique layer name',
        enterNewLayerName: 'Please enter the new layer name',
        layerHasThatName: 'Layer already has that name',
        QmoveElemsToLayer: 'Move selected elements to layer \'%s\'?',
        QwantToClear: 'Do you want to clear the drawing?\nThis will also erase your undo history!',
        QwantToOpen: 'Do you want to open a new file?\nThis will also erase your undo history!',
        QerrorsRevertToSource: 'There were parsing errors in your SVG source.\nRevert back to original SVG source?',
        QignoreSourceChanges: 'Ignore changes made to SVG source?',
        featNotSupported: 'Feature not supported',
        enterNewImgURL: 'Enter the new image URL',
        defsFailOnSave: 'NOTE: Due to a bug in your browser, this image may appear wrong (missing gradients or elements). It will however appear correct once actually saved.',
        loadingImage: 'Loading image, please wait...',
        saveFromBrowser: "Select 'Save As...' in your browser (possibly via file menu or right-click context-menu) to save this image as a {{type}} file.",
        noteTheseIssues: 'Also note the following issues: ',
        unsavedChanges: 'There are unsaved changes.',
        enterNewLinkURL: 'Enter the new hyperlink URL',
        errorLoadingSVG: 'Error: Unable to load SVG data',
        URLLoadFail: 'Unable to load from URL',
        retrieving: "Retrieving '%s' ...",
        popupWindowBlocked: 'Popup window may be blocked by browser',
        exportNoBlur: 'Blurred elements will appear as un-blurred',
        exportNoforeignObject: 'foreignObject elements will not appear',
        exportNoDashArray: 'Strokes will appear filled',
        exportNoText: 'Text may not appear as expected'
    }
};
